import React, { useEffect, useState } from 'react';
import { listChallenge } from "../../../slices/challengeSlice";
import { useDispatch, useSelector } from 'react-redux';
import Message from '../../../components/Message';
import Links from '../../../components/elements/Links';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { deleteChallengeById } from "../../../slices/challengeSlice";
import { FaPencil, FaTrashCan } from "react-icons/fa6";

const ChallengeList = ({refr}) => {
  const { challenge, message, error, loading } = useSelector((state) => state.challenge);
  const [refrState, setRefrState] = useState(refr);
  const [localItems, setLocalItems] = useState(challenge);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(listChallenge());
  }, [dispatch,refr,refrState]);

  useEffect(() => {
    setLocalItems(challenge);
  }, [challenge,refr,refrState]);

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Tem certeza?',
      text: "Você não poderá reverter esta ação!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteChallengeById(id));

        const updatedChallenges = localItems.filter((item) => item._id !== id);
        setLocalItems(updatedChallenges);

        Swal.fire('Excluído!', 'O item foi excluído com sucesso.', 'success');
        
        setRefrState((refrState) => refrState + 1);
        dispatch(listChallenge());
      }
    });
  };

  if (loading) return <p>Carregando...</p>;
  if (!loading && error) return <p>{error}</p>;
  
  return (
    <>  
    <div id={refr} className="flex items-start justify-center relative overflow-x-auto  bg-cinza-cl  shadow-md sm:rounded-lg">
    {challenge && challenge.length > 0 && challenge.length ? (
      <table className="min-w-full border border-gray-200 shadow-md rounded-lg">
        <thead>
          <tr className="bg-bordo-600 text-white font-semibold">
            <th className="content-center justify-center text-center py-3">
              Editar
            </th>
            <th className="content-center justify-center text-center py-3">
              Título
            </th>
            <th className="content-center justify-center text-center py-3">
              Dificuldade
            </th>
            <th className="content-center justify-center text-center py-3">
              Resposta
            </th>
            <th className="content-center justify-center text-center py-3">
              Data de Abertura
            </th>
            <th className="px-6 py-3 content-center justify-center text-center">
              Excluir
            </th>
          </tr>
        </thead>
        <tbody>
          {challenge.map((item) => (
            <tr key={item._id} className="text-center odd:bg-cinza-cl odd:dark:bg-bordo-50 hover:bg-gray-100 odd:text-white text-preto-suave">
              <td className="px-10 py-4 text-center">
                <Link to={`/EditChallenge/${item._id}`} >
                  <span><FaPencil /></span>
                </Link>
              </td>
              <td className="content-center justify-center text-center">
                {item.title}
              </td>
              <td className="content-center justify-center text-center">
                {item.difficulty}
              </td>
              <td className="content-center justify-center text-center">
                {item.answer}
              </td>
              <td className="content-center justify-center text-center">
                {item.openDate ? new Date(item.openDate).toLocaleDateString('pt-BR') : "N/A"}
              </td>
              <td className="px-10 py-4 text-center">
                <span onClick={() => handleDelete(item._id)}><FaTrashCan /></span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      ) : (<Message type="error" msg="Nenhum desafio encontrado"/>)}
    </div>
    </>
  );
};

export default ChallengeList;
